export const PREFIX = '$€¥£₽₨₱'.split('');

export const SUFFIX = ['%', ' cents', ' hundred', ' thousand', ' million', ' billion', ' trillion', ' pct. pts'];

const matchDigitRegex = /^[\$|€|¥|¢|£|₽|₨|₩|฿|₺|₮|₱|₭|₴|₦|৲|৳|૱|௹|﷼|₹|₲|₪|₡|₫|៛|₵|₢|₸|₤|₳|₥|₠|₣|₰|₧|₯|₶]?(\-?\d+\.?\d*)%?$/;

export const sanitizeYValue = (y) => {
  y = y.replace(/,/g, '');
  const match = y.match(matchDigitRegex);
  return match ? +match[1] : +y;
};
